import { render, staticRenderFns } from "./company-surveyor.vue?vue&type=template&id=3bcdc9cc&scoped=true&"
import script from "./company-surveyor.vue?vue&type=script&lang=js&"
export * from "./company-surveyor.vue?vue&type=script&lang=js&"
import style0 from "./company-surveyor.vue?vue&type=style&index=0&id=3bcdc9cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdc9cc",
  null
  
)

export default component.exports